module.exports = __webpack_public_path__ + "static/media/caption3.d9df5b95.png";